export const images = {
    defaultOld: require('./resource/default.png'),
    default: require('./resource/default@2x.png'),
    global: {
        blank: require('./resource/global/blank.svg'),
        empty: require('./resource/global/empty.svg'),
        zuosousuo: require('./resource/global/zuosousuo.svg'),
        yousousuo: require('./resource/global/yousousuo.svg')
    },
    top: {
        gengduo: require('./resource/gengduo.png@2x.png')
    },
    menuType: {
        template: require('./menuType/template.svg'),
        scene: require('./menuType/scene.svg'),
        word: require('./menuType/word.svg'),
        image: require('./menuType/image.svg'),
        music: require('./menuType/music.svg'),
        animate: require('./menuType/animate.svg'),
        video: require('./menuType/video.svg'),
        tool: require('./menuType/tool.svg'),
        game: require('./menuType/game.svg'),
        questionbank: require('./menuType/quesionbank.svg'),
        hot: require('./menuType/hot.svg'),
    },
    menus: {
        add: require('./menuType/add.svg'),
        ppt: require('./menuType/ppt.svg'),
        bankuai: require('./resource/bankuai.png@2x.png'),
        bankuaitianjia: require('./resource/bankuaitianjia.png@2x.png'),
        zuogengduo: require('./resource/zuogengduo.png@2x.png'),
        shousuo: require('./resource/shousuo.png@2x.png'),
        yougengduo: require('./resource/yougengduo.png@2x.png'),
        bianji: require('./resource/bianji.png@2x.png'),
        xiaotutianjia: require('./resource/xiaotutianjia.png@2x.png'),
        fengxiang: require('./resource/fengxiang.png@2x.png')
    },
    contents: {
        fanhui: require('./resource/fanhui.png@2x.png'),
        fanhuixuanzhong: require('./resource/fanhuixuanzhong.png@2x.png'),
        congxian: require('./resource/congxian.png@2x.png'),
        congxianxuanzhong: require('./resource/congxianxuanzhong.png@2x.png'),
        shijian: require('./resource/shijianweixuanzhong.png@2x.png'),
        xuanzhongshijian: require('./resource/xuanzhongshijian.png@2x.png'),
        beizhu: require('./resource/beizhuweixuanzhong.png@2x.png'),
        beizhuxuanzhong: require('./resource/beizhu.png@2x.png'),
        datu: require('./resource/datu.png@2x.png'),
        tupiansuoxiao: require('./resource/tupiansuoxiao.png@2x.png'),
        tupianfada: require('./resource/tupianfangda.png@2x.png'),
        bofang: require('./resource/bofang.png@2x.png'),
        zanting: require('./resource/zanting.png@2x.png'),
        shijianzhoubodong: require('./resource/shijianzhoubodong.png@2x.png'),
        shijianzhoujia: require('./resource/shijinazhoujia.png@2x.png'),
        shijianzhoujian: require('./resource/shijianzhoujian.png@2x.png')
    },
    types: {
        xuanzhongmoshi: require('./resource/xuanzhongmoshi.png@2x.png'),
        weixuanzhongmoshi: require('./resource/weixuanzhongmoshi.png@2x.png'),
        xuanzhongchangjing: require('./resource/xuanzhongchangjing.png@2x.png'),
        weixuanzhongchangjing: require('./resource/weixuanzhongchangjing.png@2x.png'),
        xuanzhongwenzi: require('./resource/weixuanzhongwenzi.png@2x(1).png'),
        weixuanzhongwenzi: require('./resource/weixuanzhongwenzi.png@2x.png'),
        xuanzhongtupian: require('./resource/xuanzhongtupian.png@2x.png'),
        weixuanzhongtupian: require('./resource/weixuanzhongtupian.png@2x.png'),
        xuanzhongyinpin: require('./resource/xuanzhongyinpin.png@2x(1).png'),
        weixuanzhongyinpin: require('./resource/xuanzhongyinpin.png@2x.png'),
        xuanzhongdonghua: require('./resource/xuanzhongdonghua.png@2x.png'),
        weixuanzhongdonghua: require('./resource/weixuanzhongdonghua.png@2x.png'),
        xuanzhongshiping: require('./resource/xuanzhongshiping.png@2x.png'),
        weixuanzhongshiping: require('./resource/weixuanzhongshiping.png@2x.png'),
        xuanzhongyouxi: require('./resource/xuanzhongyouxi.png@2x.png'),
        weixuanzhongyouxi: require('./resource/weixuanzhongyouxi.png@2x.png'),
        xuanzhongwode: require('./resource/xuanzhongwode.png@2x.png'),
        weixuanzhongwode: require('./resource/weixuanzhongwode.png@2x.png'),
        xihuanweixuanzhong: require('./resource/xihuanweixuanzhong.png@2x.png'),
        xuanzhongshouchang: require('./resource/xuanzhongshouchang.png@2x.png'),

        // yinpin
        weixuanzhongbofang: require('./resource/weixuanzhongbofang.png@2x.png'),
        weixuanzhongzanting: require('./resource/weixuanzhongzhanting.png@2x.png'),
        weixuanzhongshouchang: require('./resource/weixuanzhongshouchang.png@2x.png'),
        weixuanzhexuanzhong: require('./resource/weixuanzhexuanzhong.png@2x.png'),
        xuanzhexuanzhong: require('./resource/xuanzhexuanzhong.png@2x.png'),
    },
    template: {
        bianji: require('./resource/template/bianji.png@2x.png'),
        dengji: require('./resource/template/dengji.png@2x.png'),
        fenxiang: require('./resource/template/fenxiang.png@2x.png'),
        fuzhi: require('./resource/template/fuzhi.png@2x.png'),
        mingming: require('./resource/template/mingming.png@2x.png'),
        ppt: require('./resource/template/PPT.png@2x.png'),
        shangchu: require('./resource/template/shangchu.png@2x.png'),
        shangchuang: require('./resource/template/shangchuang.png@2x.png'),
        suosuo: require('./resource/template/suosuo.png@2x.png'),
        tianjia: require('./resource/template/tianjia.png@2x.png'),
        xiala: require('./resource/template/xiala.png@2x.png'),
    },
    operation: {
        xieti: require('./resource/operation/ I@2x.png'),
        zuoduiqi: require('./resource/operation/1@2x.png'),
        juzhong: require('./resource/operation/2@2x.png'),
        youduiqi: require('./resource/operation/3@2x.png'),
        liangbianduiqi: require('./resource/operation/5@2x.png'),
        jianjuduiqi: require('./resource/operation/4@2x.png'),
        ajian: require('./resource/operation/a-@2x.png'),
        ajia: require('./resource/operation/a+.png@2x.png'),
        ayanse: require('./resource/operation/A2@2x.png'),
        ayidong: require('./resource/operation/ayidong.png@2x.png'),
        b: require('./resource/operation/B@2x.png'),
        s: require('./resource/operation/s@2x.png'),
        sanjiaoxing: require('./resource/operation/sanjiaoxing.png@2x.png'),
        u: require('./resource/operation/u@2x.png'),
        xiangpicha: require('./resource/operation/xiangpicha.png@2x.png'),
        youqi: require('./resource/operation/youqi.png@2x.png'),
    },
    material: {
        default: require('./resource/material/default@2x.png'),
        add: require('./resource/material/+.png@2x.png'),
        bofang: require('./resource/material/bofang.png@2x.png'),
        bukejian: require('./resource/material/bukejian.png@2x.png'),
        dabofang: require('./resource/material/dabofang.png@2x.png'),
        dazanting: require('./resource/material/dazanting.png@2x.png'),
        guanbi: require('./resource/material/guanbi.png@2x.png'),
        kejian: require('./resource/material/kejian.png@2x.png'),
        shangchu: require('./resource/material/shangchu.png@2x.png'),
        weishouchang: require('./resource/material/weishouchang.png@2x.png'),
        yishouchang: require('./resource/material/yishouchang.png@2x.png'),
        zanting: require('./resource/material/zanting.png@2x.png'),
        blank: require('./resource/material/blank.png'),
        feedBack: require('./resource/material/feedBack.png'),
        setBackground: require('./resource/material/setBackground.svg'),
        setBackground1: require('./resource/material/setBackground1.svg'),
        catalogMore: require('./resource/material/catalogMore.svg'),
        catalogMore1: require('./resource/material/catalogMore1.svg'),
        shipingaoliang: require('./resource/shipingaoliang.svg'),
        shipinjinyong: require('./resource/shipinjinyong.svg')
    },
    guide: {
        start: require('./guide/start.png'),
        first: require('./guide/first.png'),
        second: require('./guide/second.png'),
        third: require('./guide/third.png'),
        five: require('./guide/five.png'),
        guide: require('./guide/guide.svg')
    },
    luyin: {
        luyin: require('./luyin/luyin.png'),
        zanting: require('./luyin/zanting.png'),
        bofang: require('./luyin/bofang.png'),
    },
    oper: {
        copy: require('./oper/copy.svg'),
        paste: require('./oper/paste.svg'),
        move: require('./oper/move.svg'),
        delete: require('./oper/delete.svg'),
        mulSelect: require('./oper/select.svg'),
        deleteNavItem: require('./oper/delete.svg'),
        editNavLeaf: require('./oper/add.svg'),
        editNavItem: require('./oper/edit.svg'),
        add: require('./oper/add.svg'),
        addNavItem: require('./oper/add.svg'),
        replaceNav: require('./oper/switch.svg'),
    }
}
